import CardFeaturedStory from './card-featured-story'

export default CardFeaturedStory
